import { CASES } from "./constants";

export const updateTPRExceptions = (payload) => {
  return { type: CASES.UPDATE_TPR_EXCEPTIONS, payload };
};

export const updateTPRExceptionsSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_TPR_EXCEPTIONS_SEARCH_FORM,
    payload: { key, data },
  };
};

export const clearTPRExceptions = () => {
  return { type: CASES.CLEAR_TPR_EXCEPTIONS, payload: {} };
};
